import { Check } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { useObjectScope } from '@/shared/object-scope';
import { ObjectScopeStatus } from './ObjectScopeStatus';

/**
 * Inhalt der Objektwahl, am Desktop im Popover, am Handy im Blatt; Ladefehler und fehlende
 * Verbindung zeigt `ObjectScopeStatus`.
 */
export function ObjectScopeList({ onPicked }: { onPicked: () => void }) {
  const scope = useObjectScope();
  const options = [
    { id: null, name: 'Alle erlaubten Objekte', meta: 'jedes Objekt, auf das Sie Zugriff haben' },
    ...scope.groups.map((group) => ({
      id: group.id,
      name: group.name,
      meta: `${group.visibleApartmentCount} Apartments`,
    })),
  ];
  const pick = (id: string | null) => {
    scope.setGroupId(id);
    onPicked();
  };
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-1 px-[18px] pb-2.5 pt-4">
        <p className="font-serif text-lg font-bold">Objekt</p>
        <p className="text-ink-soft text-xs leading-[1.45]">
          Gilt in allen Bereichen: Heute, Kalender, Buchungen, Nachrichten, Reinigung, Objekte,
          Finanzen und in der Suche. Bleibt gespeichert.
        </p>
      </div>
      <ObjectScopeStatus />
      <div
        role="radiogroup"
        aria-label="Objekt"
        className="flex max-h-[min(60dvh,420px)] flex-col overflow-y-auto px-2 pb-2.5"
      >
        {options.map((option, index) => {
          const checked = (scope.groupId ?? null) === option.id;
          return (
            <button
              key={option.id ?? 'all'}
              type="button"
              role="radio"
              aria-checked={checked}
              onClick={() => pick(option.id)}
              className={cn(
                'rounded-square flex min-h-[52px] items-center gap-2.5 px-3 py-1.5 text-left',
                checked ? 'bg-forest-soft' : 'hover:bg-paper',
                index === 0 && 'mb-1',
              )}
            >
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-ink truncate text-sm font-bold">{option.name}</span>
                <span className="text-ink-soft truncate text-xs">{option.meta}</span>
              </span>
              {checked && (
                <Check size={18} strokeWidth={2.4} aria-hidden className="text-forest flex-none" />
              )}
            </button>
          );
        })}
        {scope.isLoading && (
          <p className="text-ink-soft px-3 py-2 text-xs">Objekte werden geladen …</p>
        )}
      </div>
    </div>
  );
}
